import { render } from "./ChatsPreviewLoadingContainer.vue?vue&type=template&id=75281c57"
import script from "./ChatsPreviewLoadingContainer.vue?vue&type=script&lang=js"
export * from "./ChatsPreviewLoadingContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__